import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import {
  Banner,
  BannerLeft,
  BannerRight,
  BANNER_VARIANT_PURPLE,
  BannerTitle,
  BannerLink,
  Button,
  BUTTON_VARIANT_NEGATIVE,
  IconMailupShield,
} from 'mailup-web-components'
import {
  evalCondition,
  notifyParent,
  sessionStoreGet,
  sessionStoreSet,
} from 'mailup-react-helpers'
import {
  useRecoilCallback,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from 'recoil'
import {
  bannerBrandShieldState,
  deliverabilityIndexState,
  modalBrandShieldState,
} from './recoil/state'
import { useIntl } from 'react-intl'
import { deliverabilityIndexCallback } from './recoil/callbacks'
import IconBrandShield from 'Img/icon-brand-shield.svg'
import ModalBrandShield from './ModalBrandShield'
import { pendoTrack } from 'Helpers/pendoTracking'

const BannerBrandShield = () => {
  const { show } = useRecoilValue(bannerBrandShieldState)
  const setModalBrandShieldState = useSetRecoilState(modalBrandShieldState)
  const setBannerBrandShieldState = useSetRecoilState(bannerBrandShieldState)
  const {
    loaded,
    AlertsData: { BrandShield },
  } = useRecoilValue(deliverabilityIndexState)

  const intl = useIntl()

  const resetDeliverabilityIndex = useResetRecoilState(deliverabilityIndexState)
  const initDeliverabilityIndex = useRecoilCallback(
    deliverabilityIndexCallback,
    [],
  )
  const init = () => {
    initDeliverabilityIndex()
  }

  useEffect(() => {
    if (BrandShield) {
      pendoTrack('Brand Shield Upselling - Wizard invio', {})
    }
  }, [BrandShield])

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    init()
    return () => {
      resetDeliverabilityIndex()
    }
  }, [])

  const handleCloseBanner = () => {
    setBannerBrandShieldState((prev) => ({
      ...prev,
      show: false,
    }))
  }

  const showMshop = evalCondition(
    'NOT c:IsRetailer AND uo:GEST AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP',
  )
  const goToMshop = () => {
    notifyParent('redirectMainFrame', [
      '/console/mshop_Redirector.aspx?t=mshopproddet&cp=MUBRAND01',
    ])
  }
  const handleLinkMore = () => {
    setModalBrandShieldState((prev) => ({
      ...prev,
      show: true,
    }))
  }

  const renderBanner = (variant) => (
    <>
      <Banner
        variant={variant}
        onClose={() => handleCloseBanner()}
        icon={<img src={IconBrandShield} alt={''} />}
        show={show}
      >
        <BannerLeft>
          <BannerTitle bannerVariant={variant}>
            {intl.formatMessage({
              id: 'Load.UpsellBanner.BrandShieldTitleATest',
            })}
          </BannerTitle>
          <p>
            {intl.formatMessage({
              id: 'Load.UpsellBanner.BrandShieldBodyATest',
            })}
          </p>
        </BannerLeft>
        <BannerRight>
          <BannerLink
            bannerVariant={variant}
            onClick={() => handleLinkMore()}
            data-mu-test="banner-BrandShield-guideA"
          >
            {intl.formatMessage({ id: 'Load.ContentDefaults.ReadMore' })}
          </BannerLink>
          {showMshop && (
            <Button
              kind={BUTTON_VARIANT_NEGATIVE}
              onClick={goToMshop}
              data-mu-test={'banner-brandShield-buyA'}
            >
              {intl.formatMessage({ id: 'Load.MailupShield.BannerBuy' })}
            </Button>
          )}
        </BannerRight>
      </Banner>
    </>
  )

  return (
    loaded &&
    BrandShield && (
      <>
        <ModalBrandShield />
        {renderBanner(BANNER_VARIANT_PURPLE)}
      </>
    )
  )
}

export default BannerBrandShield
